import { styled } from '@mui/material/styles';

// Ascii art
export const sASCII_Orbotnik_Large = `
██████╗ ██████╗ ██████╗  ██████╗ ████████╗███╗   ██╗██╗██╗  ██╗
██╔═══██╗██╔══██╗██╔══██╗██╔═══██╗╚══██╔══╝████╗  ██║██║██║ ██╔╝
██║   ██║██████╔╝██████╔╝██║   ██║   ██║   ██╔██╗ ██║██║█████╔╝ 
██║   ██║██╔══██╗██╔══██╗██║   ██║   ██║   ██║╚██╗██║██║██╔═██╗ 
╚██████╔╝██║  ██║██████╔╝╚██████╔╝   ██║   ██║ ╚████║██║██║  ██╗
╚═════╝ ╚═╝  ╚═╝╚═════╝  ╚═════╝    ╚═╝   ╚═╝  ╚═══╝╚═╝╚═╝  ╚═╝                                      
`

export const sASCII_Orbotnik_Small = `
 _ __|_  __|___ o| 
(_)| |_)(_)|_| |||<
`





interface ItemProps {
  align?: 'left' | 'right' | 'center' | 'justify' | 'initial' | 'inherit';
}

export const Item = styled('div')<ItemProps>(({ align = 'left' }) => ({
  textAlign: align,
}));

export type SelectedTabType = string | number | true